import { DesignProp, LayoutProp } from "./PropCategories";

export const rowGap = {
  prop: "style-attribute",
  name: "Row gap",
  nameI18n: "builder_ui.prop_type.styles.row_gap",
  category: [DesignProp, LayoutProp],
  type: "slider",
  sliderProps: {
    min: 0,
    max: 320,
    step: 1,
    units: ["px", "rem", "%"],
    defaultUnit: "px",
  },
} as const;
